import ClassicLayout from "../../../layout/ClassicLayout";
import PublicTopBar from "../components/PublicTopBar";

const MainView = () => {
  return <ClassicLayout topbar={<PublicTopBar />} />;
};

export default MainView;
